import React from 'react'
import PositionJournalForm from '../../components/PositionJournalForm'
import { Formik, FormikHelpers } from 'formik'
import { positionJournalSchema } from '../../components/PositionJournalForm/positionJournalValidations'
import { PositionJournalValues } from './types'
import { connect } from 'react-redux'
import { RootState } from '../../store'
import { ApexAccounts } from 'apex-ui-services'
import { AccountDetailResponsePayload } from '@Types'
import useAccount from '../../hooks/useAccount'

import { useCreatePositionJournal } from '../../api/useCreatePositionJournal'
import formatPayload from './formatPayload'
import { useDisclosure } from '@chakra-ui/react'
import { useQueryClient } from 'react-query'
import queryKeys from '../../api/queryKeys'

export interface PositionJournalsProps {
  accountDetails?: AccountDetailResponsePayload | null
  hasSubmitPermission: boolean
}

const PositionJournals = ({ accountDetails, hasSubmitPermission }: PositionJournalsProps) => {
  const { account } = useAccount()
  const submitPositionJournalTransfer = useCreatePositionJournal()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const queryClient = useQueryClient()

  if (accountDetails && account) {
    const defaultValues = {
      accountNumber: account.accountNumber
    }

    const formikConfig = {
      initialValues: positionJournalSchema(defaultValues).cast({}),
      onSubmit: (values: PositionJournalValues, formikHelpers: FormikHelpers<any>) => {
        formikHelpers.setSubmitting(true)
        submitPositionJournalTransfer.mutate(formatPayload(values), {
          onSuccess: () => {
            queryClient.invalidateQueries(queryKeys.accountLookup)
            formikHelpers.resetForm()
          },
          onSettled: () => {
            formikHelpers.setSubmitting(false)
            onClose()
          }
        })
      },
      validationSchema: () => positionJournalSchema(defaultValues),
      validateOnMount: true,
      validateOnChange: true,
      validateOnBlur: true
    }

    return (
      <Formik {...formikConfig}>
        <PositionJournalForm
          account={account}
          accountDetails={accountDetails}
          hasSubmitPermission={hasSubmitPermission}
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
        />
      </Formik>
    )
  }
  return <div>Loading...</div>
}

const mapStateToProps = (state: RootState) => {
  return {
    accountDetails: ApexAccounts.accounts.selectors.accountDetails(state)
  }
}

export default connect(mapStateToProps)(PositionJournals)
